import RecipesFilters from './RecipesFilters';
import GroceriesFilters from './GroceriesFilters';
import SideBar from './SideBar';
import { withRouter } from 'react-router-dom';
import { recipesPath } from '../../customize/const';
import { useMedia } from 'react-use';
import { MobileQueryLegacyInvertedPattern } from '@hungryroot/tokens';
import { FocusScope } from 'react-aria';

const FilterSidebar = ({ isFoods, filtersVisibility }) => {
  const isMobile = useMedia(MobileQueryLegacyInvertedPattern);
  const filters = !isFoods ? <RecipesFilters /> : <GroceriesFilters />;

  return (
    <SideBar type="filters">
      <div className="hr-title-md">
        {!isFoods ? 'Filter Recipes' : 'Filter Groceries'}
      </div>
      {/* on mobile, the filters are shown in a modal, so we use FocusScope to manage focus;
      furthermore, we need to prevent the filters content from rendering in the DOM unless
      it's visible, otherwise the FocusScope will prevent other parts of the page from being
      focused */}
      {filtersVisibility && isMobile ? (
        <FocusScope contain restoreFocus autoFocus>
          {filters}
        </FocusScope>
      ) : (
        filters
      )}
    </SideBar>
  );
};

export default FilterSidebar;
